import { axiosPrivate } from "@/api/axios";
import { DataTable } from "@/components/ui/data-table";
import { feedColumns } from "@/lib/columns";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import useCategories from "@/hooks/useCategories";
import React from "react";

function Feed() {
  const { data, isLoading } = useQuery({
    queryKey: ["feeds"],
    queryFn: async () => {
      const response = await axiosPrivate.get("/feeds/");
      if (response.data.success) return response.data.data;
      else {
        toast.error("Failed to fetch feeds. Please try again later.");
        throw new Error("Failed to fetch feeds.");
      }
    },
  });
  // Fetch feed categories to resolve category names
  const { data: feedCategories } = useCategories();

  const tableData = React.useMemo(() => {
    if (!data) return [] as any[];
    const map: Record<number, string> = {};
    (feedCategories || []).forEach(c => { map[c.id] = c.name; });
    return data.map((f: any) => ({
      ...f,
      category_name: f.category_name || map[f.category_id] || "",
    }));
  }, [data, feedCategories]);
  return (
    <div className="space-y-4">
      <h1 className="text-3xl">Feed Management</h1>
      <p>Manage all feeds in one place.</p>
      <DataTable
        columns={feedColumns}
        data={tableData}
        placeholder="Filter Feeds"
        filterColumns={["title", "category_name"]}
      />
    </div>
  );
}

export default Feed;
